import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import methodCommon from '@/utils/methodCommon'

const whiteList = ['/login']

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      // 变身对象的 roles 有机率 null，这会导致页面坏掉，所以要先确认 roles 是否有值再判断长度
      if (store.getters.roles && store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then((res) => { // 拉取用户信息
          document.title = (store.state.app.switchProjectObj.title && res.data.userType) ? `${store.state.app.switchProjectObj.title} ${methodCommon.methods.translateUserType(res.data.userType)}` : '';
          store.dispatch('GenerateRoutes', store.getters.menus).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
            next({ ...to, replace: true })
          })
        }).catch(() => {
          store.dispatch('FedLogOut').then(() => {
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // Start check version
  let ElementVersionHash = document.getElementById("version-hash");
  if (ElementVersionHash) ElementVersionHash.parentNode.removeChild(ElementVersionHash);
  let HashVersionCheck = document.createElement("script");
  HashVersionCheck.setAttribute("src", './static/version.js?' + Date.now());
  HashVersionCheck.setAttribute("id", 'version-hash');
  document.body.appendChild(HashVersionCheck);
  // End check version

  NProgress.done()
})


// WEBPACK FOOTER //
// ./src/permission.js